import type { JSX } from "react";

export const BadgeActiveFilter = (): JSX.Element => {
  return (
    <div
      aria-label="Active filters"
      className="absolute top-0 right-[-2px] bg-secondary-500 rounded-full w-[10px] h-[10px]"
    />
  );
};
